import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Routes,Router,RouterModule,ActivatedRoute}  from '@angular/router';

import { AppComponent } from '../../../app.component';

import { TopnavComponent } from '../../../topnav/topnav.component';
import { SidemenuComponent } from '../../../sidemenu/sidemenu.component';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { AppSettings } from '../../../appSettings';
import { LoginService } from '../../../services/login.service';
import { CommonService } from '../../../services/common.service';
import { ImageCroppedEvent } from 'ngx-image-cropper';
declare var jquery:any;
declare var $ :any;
import { Injectable } from '@angular/core';

@Component({
  selector: 'app-editarticle',
  templateUrl: './editarticle.component.html',
  styleUrls: ['./editarticle.component.css']
})
export class EditarticleComponent implements OnInit, AfterViewInit, OnDestroy {

  currentUser:any;
  currentUserID:any;
  currentUsername:any;
  currentUsergroup:any;
  currentUserStatus:any;
  currentAllUsers:any;
  select: any;
  getarticlecategorylistbyuserid:string = AppSettings.getarticlecategorylistbyuserid;
  uploaduserProfileApi:string=AppSettings.uploadcropimage;
  FetcharticleRestApiUrl:string = AppSettings.editarticle;
  updatearticleRestApiUrl:string = AppSettings.updatearticle;
  image_url = AppSettings.IMAGE_BASE;
  categorylist:Array<Object>;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  private sub: any;
  id:number;
  model: any = {};
  model1:any={};
  alldata: any = {};
  localdata:any={};
  statusOptions: any[] = [
    { value: 'published', label: 'Published' },
    { value: 'draft', label: 'Draft' }
  ];

  @ViewChild('contentEditor') contentEditor!: ElementRef;
  constructor(private loginService: LoginService,private CommonService: CommonService,private route: ActivatedRoute,private router: Router,private http:Http) { 
      document.body.className="theme-red";

  }

  ngOnInit() {
  	 this.loginService.localStorageData();
      this.loginService.viewsActivate();
      /*category list*/
     let user_id = localStorage.getItem('currentUserID');
     this.localdata.imagePath = AppSettings.API_BASE;
    this.localdata.usergroup=localStorage.getItem('currentUsergroup');

    // Load article categories
    this.CommonService.getdata(this.getarticlecategorylistbyuserid + user_id)
    .subscribe(resultdata =>{
        if(resultdata.result!="")
        {
          this.categorylist=resultdata.result;
        }
    });

     this.sub = this.route.params.subscribe(params => {
        this.id = +params['id']; // (+) converts string 'id' to a number
        this.editarticle(this.id);
        });
  }

  editarticle(id:any)
  {
  	this.CommonService.editdata(this.FetcharticleRestApiUrl,id)
        .subscribe(resultdata =>{
          this.model = resultdata.result;
        });
  }
  updatearticle()
  {
    // Get content from custom editor
    if (this.contentEditor) {
      this.model.content = this.contentEditor.nativeElement.innerHTML;
    }

  	this.CommonService.updatedata(this.updatearticleRestApiUrl,this.model)
    .subscribe(package_det =>{
         swal(package_det.status,package_det.message,package_det.status)
         this.router.navigate(['/managearticles']);
    });
  }
  // Rich text editor methods
  formatText(command: string, value?: string) {
    document.execCommand(command, false, value);
    if (this.contentEditor) {
      this.model.content = this.contentEditor.nativeElement.innerHTML;
    }
  }

  insertLink() {
    const url = prompt('Enter URL:');
    if (url) {
      document.execCommand('createLink', false, url);
      if (this.contentEditor) {
        this.model.content = this.contentEditor.nativeElement.innerHTML;
      }
    }
  }

  onContentChange() {
    if (this.contentEditor) {
      this.model.content = this.contentEditor.nativeElement.innerHTML;
    }
  }

  fileEvent($event) {
    const fileSelected: File = $event.target.files[0];

    this.CommonService.uploadFile(this.uploaduserProfileApi,fileSelected)
    .subscribe( (response) => {
       if(response.status=='success')
       {
        this.model.image = response.data;
       }
        else{
          swal('',"Error while on upload photo",'Oops!');
        }
     })
   }
  back(){
    this.router.navigate(['/managearticles']);
  }

  ngAfterViewInit() {
    // Initialize content editor
    setTimeout(() => {
      if (this.contentEditor && this.model.content) {
        this.contentEditor.nativeElement.innerHTML = this.model.content;
      }
    }, 100);
  }

  ngOnDestroy() {
    // No cleanup needed for custom editor
  }
 

  fileChangeEvent(event: any): void {
        this.imageChangedEvent = event;
    }
  imageCropped(event: ImageCroppedEvent) {
        this.croppedImage = event.base64;
        this.model1.Imagefile = event.base64;
        this.CommonService.insertdata(this.uploaduserProfileApi,this.model1)
      .subscribe( (response) => {
         if(response.status=='success')
         {
          this.model.image = response.data;
        }
     })
    }
}
